
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class RateFixingGrid extends Serenity.EntityGrid<RateFixingRow, any> {
        protected getColumnsKey() { return 'Purchase.RateFixing'; }
        protected getDialogType() { return RateFixingDialog; }
        protected getIdProperty() { return RateFixingRow.idProperty; }
        protected getInsertPermission() { return RateFixingRow.insertPermission; }
        protected getLocalTextPrefix() { return RateFixingRow.localTextPrefix; }
        protected getService() { return RateFixingService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date();
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(43);
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[43].AutoPosting;

            this.editItem(<RateFixingRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 43,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}